'use client';

import { Camera } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { EmptyState } from '@/shared/ui/EmptyState';

interface AnglesEmptyStateProps {
  onAddClick: () => void;
}

export function AnglesEmptyState({ onAddClick }: AnglesEmptyStateProps) {
  const t = useTranslations('angles');

  return (
    <EmptyState
      icon={<Camera />}
      title={t('noAngles')}
      description={
        <>
          {t('noAnglesDescription')}
          <span className="mt-2 block">{t('noAnglesHint')}</span>
        </>
      }
      action={{
        label: t('addAngle'),
        onClick: onAddClick,
      }}
      centered
    />
  );
}
